export const UI_USER = 'Mercury_UI'
